import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const DisplayThresholdAndScaling = ({
  BLOCK,
  thresholdScaling,
  displayThreshold = true,
  displayScaling = true,
}) => {
  return (
    <div className={`${BLOCK}__threshold-scaling-container`}>
      {displayThreshold && thresholdScaling?.threshold && (
        <>
          <span className={`${BLOCK}__text-value`}>
            <FormattedMessage id="trial-balance-view-set-threshold-and-scaling.modal.threshold" />
          </span>
          :
          <span className={`${BLOCK}__text-value`}>
            {thresholdScaling?.threshold}
          </span>
        </>
      )}
      {displayScaling && thresholdScaling?.scaling && (
        <>
          ,
          <span className={`${BLOCK}__text-value`}>
            <FormattedMessage id="trial-balance-view-set-threshold-and-scaling.modal.scaling" />
          </span>
          :
          <span className={`${BLOCK}__text-value`}>
            <FormattedMessage id={thresholdScaling?.scaling?.title} />
          </span>
        </>
      )}
    </div>
  );
};

DisplayThresholdAndScaling.propTypes = {
  thresholdScaling: PropTypes.shape({
    threshold: PropTypes.string,
    scaling: PropTypes.string,
  }).isRequired,
  BLOCK: PropTypes.string.isRequired,
  toggleSetThresholdAndScalingModal: PropTypes.func.isRequired,
  displayThreshold: PropTypes.bool,
  displayScaling: PropTypes.bool,
};

export default DisplayThresholdAndScaling;
